import React from 'react'

export default function About() {
  return (
    <>
    This is the about page
    </>
  )
}
